import { render, staticRenderFns } from "./ReassignPathologistModal.vue?vue&type=template&id=2a52d818&scoped=true&"
import script from "./ReassignPathologistModal.vue?vue&type=script&lang=js&"
export * from "./ReassignPathologistModal.vue?vue&type=script&lang=js&"
import style0 from "./ReassignPathologistModal.vue?vue&type=style&index=0&id=2a52d818&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a52d818",
  null
  
)

export default component.exports